import { render, staticRenderFns } from "./HomeTecnologia.vue?vue&type=template&id=5202e172&scoped=true&"
import script from "./HomeTecnologia.vue?vue&type=script&lang=js&"
export * from "./HomeTecnologia.vue?vue&type=script&lang=js&"
import style0 from "./HomeTecnologia.vue?vue&type=style&index=0&id=5202e172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5202e172",
  null
  
)

export default component.exports